import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const whereAsync = (source, predicate) => {
    if (predicate.length === 1) {
        return whereAsync1(source, predicate);
    }
    else {
        return whereAsync2(source, predicate);
    }
};
const whereAsync1 = (source, predicate) => {
    async function* iterator() {
        for await (const item of source) {
            if (await predicate(item) === true) {
                yield item;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
const whereAsync2 = (source, predicate) => {
    async function* iterator() {
        let i = 0;
        for await (const item of source) {
            if (await predicate(item, i++) === true) {
                yield item;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
